import React from 'react';
import { string } from 'prop-types';
import routes from '../../routes';

const StepRenderer = ({ stepName }) => React.createElement(routes[stepName]);

StepRenderer.propTypes = {
  stepName: string.isRequired,
};

export default StepRenderer;
